import { ArrowUpRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'

interface ProjectCardProps {
  image: string
  title: string
  category: string
}

export function ProjectCard({ image, title, category }: ProjectCardProps) {
  const { t } = useTranslation()

  return (
    <LocalizedLink to="projects" className="group relative block aspect-[4/3] overflow-hidden rounded-xl bg-heading">
      <img
        src={image}
        alt={title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-90" />
      <div className="absolute top-4 right-4 flex items-center justify-center w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm text-white opacity-0 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
        <ArrowUpRight className="h-5 w-5" />
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
        <div className="flex items-center gap-2">
          <span className="h-px w-6 bg-brand" aria-hidden="true" />
          <p className="text-xs font-semibold uppercase tracking-wider text-brand">{category}</p>
        </div>
      </div>
      <span className="sr-only">{t('buttons.viewProjects')}: {title}</span>
    </LocalizedLink>
  )
}
